import o from "next/dynamic";
const E = 150, O = 150, _ = 450, t = o(() => import("react-remove-scroll/sidecar"), {
  ssr: !1
});
export {
  E as MODAL_FADE_TIMEOUT,
  _ as MODAL_SLIDE_CLOSE_TIMEOUT,
  O as MODAL_SLIDE_OPEN_TIMEOUT,
  t as sidecar
};
